import { Pagination } from "@mui/material";
import { ChangeEvent } from "react";
import { CustomSelect } from "../select/custom-select";
import ChevronDownArrow from "../select/chevron-down";

interface PaginationProps {
  currentPage: number;

  totalPages: number;

  sizePage: number;

  total: number;

  onPageChange: (page: number) => void;

  onPageSizeChange?: (pageSize: number) => void;
}

function PaginationMui({
  currentPage,
  totalPages,
  sizePage,
  total,
  onPageChange,
  onPageSizeChange,
}: PaginationProps) {
  const handleChange = (_: ChangeEvent<unknown>, value: number) => {
    onPageChange(value);
  };

  const handlePageSizeChange = (pageSize: number) => {
    onPageSizeChange && onPageSizeChange(pageSize);
  };

  return (
    <div className="flex justify-between items-center">
      <p className="text-[#A6A8B1] text-[14px]">
        Showing {sizePage * (currentPage - 1) + 1} to{" "}
        {sizePage * currentPage > total ? total : sizePage * currentPage} of{" "}
        {total} entries
      </p>
      <div className="flex gap-2 items-center">
        <div className="flex gap-1 items-center">
          <CustomSelect
            options={[
              { label: "20", value: 20 },
              { label: "50", value: 50 },
              { label: "100", value: 100 },
              { label: "500", value: 500 },
            ]}
            className="w-[60px] !h-[23px] bg-[rgba(94,99,102,0.08)] !border-none px-1 rounded-lg"
            optionContainerClassName="top-[23px] w-[60px]"
            optionClassName="!min-h-[23px] text-xs text-black whitespace-nowrap px-3"
            labelSelectedClassName="black-50 text-xs"
            arrow={<ChevronDownArrow />}
            defaultValue={20}
            hasBgColorHover
            onChange={(pageSize) => handlePageSizeChange(Number(pageSize))}
          />
          <div className="black-20 text-sm mr-[22px]">Items per page</div>
        </div>

        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handleChange}
          shape="rounded"
          color="primary"
          sx={{
            "& .MuiPaginationItem-root": {
              color: "#6E7079",
              backgroundColor: "#EFF1F9",
              fontSize: "12px",
            },
            "& .Mui-selected": {
              backgroundColor: "#5570F1",
              color: "#FFFFFF",
              fontSize: "12px",
            },
          }}
        />
      </div>
    </div>
  );
}

export default PaginationMui;
